import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'BaseTrunPage',
  data: function data() {
    return {
      baseTrunDrawer: false,
      mainKeys: []
    };
  },
  props: {
    selectedRowKeys: {
      type: Array
    },
    records: {
      type: Array
    }
  },
  methods: {
    handleSearchTableLoad: function handleSearchTableLoad() {
      this.baseTrunDrawer = true;
      var $table = this.$parent.$refs.xTable;
      var collectColumn = $table.collectColumn;
      var tempData = [];
      collectColumn.forEach(function (item) {
        if (item.property && item.visible) {
          var obj = {};
          obj.field = item.property;
          obj.title = item.title;
          obj.width = item.minWidth;
          tempData.push(obj);
        }
      });
      this.mainKeys = tempData;
    }
  }
};